module.exports = __webpack_public_path__ + "static/media/237.ae72abda.wav";